import { NavLink } from 'react-router';

import { ComplianceBadges } from '@/shared/components/ComplianceBadges';

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-border flex h-[64px] items-center border-t bg-white px-4">
      <div className="flex w-full flex-wrap items-center justify-between gap-3">
        <p className="text-muted-foreground text-xs">
          &copy; {year} ChartAI. All rights reserved.{' '}
          <span style={{ fontSize: '9px' }} className="opacity-50" title={`build ${__BUILD_SHA__}`}>
            v{__APP_VERSION__}
          </span>
        </p>
        <ComplianceBadges size="sm" />
        <nav aria-label="Footer links" className="flex flex-wrap items-center gap-4">
          <NavLink
            to="/legal/privacy"
            className="text-muted-foreground hover:text-foreground text-xs transition-colors"
          >
            Privacy Policy
          </NavLink>
          <NavLink
            to="/legal/terms"
            className="text-muted-foreground hover:text-foreground text-xs transition-colors"
          >
            Terms of Service
          </NavLink>
          <NavLink
            to="/dashboard/release-notes"
            className="text-muted-foreground hover:text-foreground text-xs transition-colors"
          >
            Release Notes
          </NavLink>
          <NavLink
            to="/dashboard/support"
            className="text-muted-foreground hover:text-foreground text-xs transition-colors"
          >
            Support
          </NavLink>
          <a
            href="mailto:hello@chartai.ai"
            className="text-muted-foreground hover:text-foreground text-xs transition-colors"
          >
            Contact
          </a>
        </nav>
      </div>
    </footer>
  );
}
